import { PricingPageWrapper } from "../../Styles/Frontend/PricingStyle";

const PricingPage = () => {
    return (
        <>
            <PricingPageWrapper>
                <div className="heading_sec">
                    <div className="sec_content">
                        <a>Institutional Scale Pricing</a>
                        <h2>Transparent growth for <span>modern campuses.</span></h2>
                        <p>Empowering academic excellence with predictable, student-centric licensing. No hidden fees,
                            just pure cognitive sanctuary.</p>
                    </div>
                </div>

                <div className="pricing_content_sec">
                    <div className="sec_content">
                        <div className="left_content">
                            <div className="left_inner">
                                <div className="left_item_top">
                                    <a><i className="fa-solid fa-graduation-cap"></i></a>
                                    <span>Core Module</span>
                                </div>
                                <div className="left_items">
                                    <h5>Base License</h5>
                                    <p>Includes LMS, Attendance, Examination, and Fee Management for every enrolled student.</p>
                                    <a> <span>₹200</span> / student</a>
                                    <ul>
                                        <li>
                                            <i class="fa-solid fa-circle-check"></i>
                                            <span>Centralized Student Database</span>
                                        </li>
                                        <li>
                                            <i class="fa-solid fa-circle-check"></i>
                                            <span>Parent-Teacher Portal</span>
                                        </li>
                                        <li>
                                            <i class="fa-solid fa-circle-check"></i>
                                            <span>Analytics Dashboard</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="right_content">
                            <div className="right_inner">
                                <div className="right_top_sec">
                                    <div className="top_box">
                                        <div className="box_head">
                                            <div className="head_img">
                                                <img src="/images/hostel.svg" alt="" />
                                            </div>
                                            <h6>Hostel Facility</h6>
                                        </div>
                                        <div className="box_item">
                                            <p>Integrated dormitory management, room allocation, and mess billing systems.</p>
                                            <a> <span>₹30</span> / student</a>
                                        </div>
                                    </div>
                                    <div className="top_box">
                                        <div className="box_head">
                                            <div className="head_img">
                                                <img src="/images/travel.svg" alt="" />
                                            </div>
                                            <h6>Travel Facility</h6>
                                        </div>
                                        <div className="box_item">
                                            <p>Real-time fleet tracking, route optimization, and driver management portal.</p>
                                            <a> <span>₹30</span> / student</a>
                                        </div>
                                    </div>
                                    <div className="top_box">
                                        <div className="box_head">
                                            <div className="head_img">
                                                <img src="/images/Accounting Icon.svg" alt="" />
                                            </div>
                                            <h6>Acconting</h6>
                                        </div>
                                        <div className="box_item">
                                            <p>Real-time fleet tracking, route optimization, and driver management portal.</p>
                                            <a> <span>₹40</span> / student</a>
                                        </div>
                                    </div>
                                    <div className="top_box">
                                        <div className="box_head">
                                            <div className="head_img">
                                                <img src="/images/Books Icon.svg" alt="" />
                                            </div>
                                            <h6>Library Management</h6>
                                        </div>
                                        <div className="box_item">
                                            <p>Real-time fleet tracking, route optimization, and driver management portal.</p>
                                            <a> <span>₹25</span> / student</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="right_bottom_sec">
                                    <div className="bottom_box">
                                        <div className="box_img">
                                            <img src="/images/ecosystem.svg" alt="" />
                                        </div>
                                        <div className="box_content">
                                            <h6>Ecosystem Bundle</h6>
                                            <p>Get both Hostel & Travel facilities at a discounted rate.</p>
                                        </div>
                                        <div className="box_price">
                                            <a><del>₹60</del><span>₹50</span></a>
                                            <p>SAVE 10/- PER STUDENT</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="Administrative_sec">
                    <div className="sec_content">
                        <div className="left_sec"></div>
                        <div className="right_sec">
                            <div className="sec_inner">
                                <h4>Designed for <span>Administrative Calm</span></h4>
                                <p>Unlike fragmented systems, Edu Connekt provides a single source of truth. Our pricing model reflects this unity—modular but integrated, expensive in capability but accessible in cost.</p>
                                <div className="inner_items">
                                    <div className="item">
                                        <div className="item_img">
                                            <img src="/images/chart.svg" alt="" />
                                        </div>
                                        <div className="item_content">
                                            <a>Real-time Budgeting</a>
                                            <span>See immediate ROI on your student services from a single console.</span>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="item_img">
                                            <img src="/images/security.svg" alt="" />
                                        </div>
                                        <div className="item_content">
                                            <a>Institutional Security</a>
                                            <span>All plans include enterprise-grade encryption and 99.9% uptime SLA.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="faq_sec">
                    <div className="sec_content">
                        <div className="sec_head">
                            <h3>Frequently Asked Questions</h3>
                        </div>
                        <div className="faq_content_sec">
                            <div className="faq_box">
                                <div className="box_top">
                                    <h6>How is the student count calculated?</h6>
                                    <a>
                                        <i class="fa-solid fa-angle-down"></i>
                                    </a>
                                </div>
                                <div className="box_bottom">
                                    <p>We count active enrollments at the start of each academic quarter. Archived student records do not incur additional licensing costs.</p>
                                </div>
                            </div>
                            <div className="faq_box">
                                <div className="box_top">
                                    <h6>How is the student count calculated?</h6>
                                    <a>
                                        <i class="fa-solid fa-angle-down"></i>
                                    </a>
                                </div>
                                <div className="box_bottom">
                                    <p>We count active enrollments at the start of each academic quarter. Archived student records do not incur additional licensing costs.</p>
                                </div>
                            </div>
                            <div className="faq_box">
                                <div className="box_top">
                                    <h6>How is the student count calculated?</h6>
                                    <a>
                                        <i class="fa-solid fa-angle-down"></i>
                                    </a>
                                </div>
                                <div className="box_bottom">
                                    <p>We count active enrollments at the start of each academic quarter. Archived student records do not incur additional licensing costs.</p>
                                </div>
                            </div>
                            <div className="faq_box">
                                <div className="box_top">
                                    <h6>How is the student count calculated?</h6>
                                    <a>
                                        <i class="fa-solid fa-angle-down"></i>
                                    </a>
                                </div>
                                <div className="box_bottom">
                                    <p>We count active enrollments at the start of each academic quarter. Archived student records do not incur additional licensing costs.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PricingPageWrapper>
        </>
    );
}

export default PricingPage;